module.exports = __webpack_public_path__ + "media/images/service/patent_bg-678a4e046e62c4dda49cd66f55c9d346.jpg";